module.exports = __webpack_public_path__ + "static/media/h4g1.9a3a5146.png";